const ROUTES = {
    base: '/',
    symbol: '/symbol/:symbol',
    spread: '/spread/:spread',
    strategy: '/strategy/:basketId',
    chart: '/chart/:layoutId?',
    optionChain: '/option-chain/:exchange?/:symbol?',
    strategyBuilder: '/strategy-builder/:exchange?/:symbol?',
    openInterestChange: '/open-interest-change/:exchange?/:symbol?',
    openInterest: '/open-interest/:exchange?/:symbol?',
    multiStrikeChart: '/multi-strike-chart/:exchange?/:symbol?',
    screener: '/screener/:screenerId?',
    fiiDii: '/fii-dii',
    fiiDiiSummary: '/fii-dii/summary',
    fiiDiiFuturesOptions: '/fii-dii/futures-options',
    fiiDiiCashMarket: '/fii-dii/cash-market',
    fiiDiiFiiHistory: '/fii-dii/fii-history',
    reports: '/reports',
    settings:'/settings',
    profile: '/profile',
    login: '/login',
    admin: '/admin',
    cache: '/admin/cache',
    globalNotification: '/admin/global-notification',
    watchList: '/admin/watchList',
    mixpanel: '/admin/mixpanel',
    communityScreens: '/admin/community-screens',
    adminTradingAccounts: '/admin/trading-accounts',
    adminUserFeatures: '/admin/user-features',
    signup: '/signup',
    oauthRedirect: '/oauth/redirect',
    googleRedirect: '/oauth/redirect/google',
    xRedirect: '/oauth/redirect/x',
    zerodhaRedirect: '/oauth/redirect/zerodha',
    upstoxRedirect: '/oauth/redirect/upstox',
    angelOneRedirect: '/oauth/redirect/angelone',
    fyresRedirect: '/oauth/redirect/fyres',
    dashboard: '/dashboard',
    userStatus: '/userstatus',
    blocked: '/userstatus/revoked',
    waitlist: '/userstatus/waitlist',
    upstoxOrdersPostback: 'postback/upstox',
    lightweightCharts: '/lightweight-charts',
    automation: '/automation/:exchange?/:symbol?',
    simulator: '/simulator/:exchange?/:symbol?',
    tradingAccount: '/trading-account',
    tradingAccountConnect: '/trading-account/:broker',
    scalper: '/scalper',
    embeddedHome: '/embedded-home',
    embeddedChart: '/embedded-chart',
    embeddedStrategyChart: '/embedded-strategyChart',
    embeddedScalper: '/embedded-scalper',
    screenerExplore: '/screener/explore',
    embeddedPayoff: '/embedded-payoff/:exchange?/:symbol?',
    embeddedMultistrike: '/embedded-multistrike/:exchange?/:symbol?'
}

export default ROUTES

export const UNPROTECTED_ROUTES = [ROUTES.login, ROUTES.oauthRedirect]
export const O_AUTH_ROUTES = [
    ROUTES.oauthRedirect,
    ROUTES.googleRedirect,
    ROUTES.xRedirect,
    ROUTES.zerodhaRedirect,
    ROUTES.upstoxRedirect,
    ROUTES.angelOneRedirect,
    ROUTES.fyresRedirect
]

export const ADMIN_ROUTES = [ROUTES.admin, ROUTES.cache, ROUTES.globalNotification, ROUTES.mixpanel]